import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09aceede"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strategy-title-wrapper" }
const _hoisted_2 = { class: "strategy-title" }
const _hoisted_3 = { class: "strategy-remark" }
const _hoisted_4 = { class: "strategy-tags" }




export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyHeader',
  props: {
    strategyName: null,
    tags: null,
    isDark: { type: Boolean },
    strategyDetails: null,
    remark: null
  },
  setup(__props: any) {

const props = __props as {
  strategyName: string
  tags: string[]
  isDark: boolean
  strategyDetails?: Record<string, any>
  remark?: string
}



return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card strategy-header-card", { 'is-dark': __props.isDark }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tooltip, {
        title: __props.strategyName,
        placement: "topLeft",
        overlayClassName: __props.isDark ? 'dark-tooltip' : ''
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.strategyName), 1)
        ]),
        _: 1
      }, 8, ["title", "overlayClassName"]),
      (__props.remark)
        ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            title: __props.remark,
            placement: "topLeft",
            overlayClassName: __props.isDark ? 'dark-tooltip' : ''
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.remark), 1)
            ]),
            _: 1
          }, 8, ["title", "overlayClassName"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
        return (_openBlock(), _createElementBlock("span", {
          key: tag,
          class: "tag"
        }, _toDisplayString(tag), 1))
      }), 128))
    ])
  ], 2))
}
}

})